<div class="diff-header">
  <span class="diff-header__label diff-header__label--original">Original</span>
  <span class="diff-header__label diff-header__label--modified">Modified — edit this side</span>
</div>
<ngx-monaco-diff-editor [style.height]="height()" [options]="editorOptions" [originalModel]="placeholderModel()"
  [modifiedModel]="placeholderModel()" (onInit)="onEditorInit($event)"></ngx-monaco-diff-editor>
